<template>
  <div class="c-app">
    <TheSidebar />
    <CWrapper>

      <TheHeader />
      <div class="c-body">
        <main class="c-main p-0">
          <CContainer
            fluid
            class="px-0 w-auto h-100 d-flex"
          >
            <transition name="fade">
              <router-view :key="$route.params.id"></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter class="mt-4" />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";
const axios = require("axios");

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
  },
  //name: "App",

  data() {
    return {
      url: "https://laravel.bikersecodelivery.com.br",
      drawer: null,
      notif: [],
      qnt: null,
      qnt2: null,

      carregouImg: false,
    };
  },

  computed: {
    verificaTipo() {
      if (this.$store.getters.getTipo == "PE") {
        return true;
      }
      if (
        this.$store.getters.getTipo == "AD" ||
        this.$store.getters.getTipo == "SA"
      ) {
        if (this.$store.getters.getNotificaSolicitacao == 1) return true;
      }
      return false;
    },
    getLogado() {
      return this.$store.getters.getLogado;
    },
    getDesativado() {
      return this.$store.getters.getDesativado;
    },
    getNome() {
      return this.$store.getters.getNome;
    },
    getFotoPerfil() {
      return this.$store.getters.getFotoPerfil;
    },
    getId() {
      if (this.$store.getters.getTipo != "CO")
        return "#" + this.$store.getters.getId;
      return null;
    },

    getTipo() {
      return this.$store.getters.getTipo;
    },
    getToken() {
      return this.$store.getters.getToken;
    },
    getPadding() {
      if (this.$route.name != "Login") return "pt-5";
      else return "";
    },
  },
  mounted() {},
  created() {
         if (window.location.hostname == "bikersecodelivery.com.br" || window.location.hostname == "www.bikersecodelivery.com.br" ) {

      this.url = "https://laravel.bikersecodelivery.com.br";
    } else if (window.location.hostname == "localhost") {
      this.url = "http://127.0.0.1:8000";
    }
    else if (window.location.hostname == "teste.bikersecodelivery.com.br") {

      this.url = "https://teste-laravel.bikersecodelivery.com.br";
    }

    // this.url = "https://laravel.bikersecodelivery.com.br";
    this.qnt = null;

    sessionStorage.setItem("url", this.url);

    if (this.getToken) {
      axios
        .get(sessionStorage.getItem("url") + "/api/usuario-autenticado", {
          headers: { Authorization: "Bearer " + this.getToken },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired") {
            this.$store.commit("DESTROY_USER");
            this.$router.push("/");
          }
          this.$store.commit("SET_USER", response.data);
          this.atualiza_notificacoes(response.data.id);
          if (response.data.desativado == 1) {
            this.$router.push("/");
          }
          if (response.data.desativado == 2) {
            this.$router.push("/configuracoes");
          }
          this.carregouImg = true;
          this.initialize();
        });
    } else {
      this.logout;
    }
  },
  methods: {
    getColorTeste(x) {
      if (window.location.hostname == "teste.bikersecodelivery.com.br")
        return "#0093ff";
      else return "light-green darken-3";
    },
    checa_page(page) {
      if (page != "404" && page != "Login") {
        return true;
      } else return false;
    },
    initialize() {
      if (this.getTipo != "CO") {
        this.$socket.$subscribe("CountSolicAbertas", (data) => {
          this.qnt2 = data;
        });
      }
    },
    logout() {
      this.close_websocket();
      this.$store.commit("DESTROY_USER");
      this.$router.push("/");
    },
    close_websocket() {
      this.$socket.client.close();
    },
    atualiza_notificacoes() {
      if (this.getToken) {
        axios
          .get(
            sessionStorage.getItem("url") + "/api/notificacoes-usuario/normal",
            {
              headers: { Authorization: "Bearer " + this.getToken },
            }
          )
          .then((response) => {
            if (response.data.status == "Token is Expired") {
              this.$store.commit("DESTROY_USER");
              this.$router.push("/");
            }
            this.qnt = response.data.qnt;
            this.notif = response.data.notif;
          });
        if (this.getTipo != "CO") {
          axios
            .get(sessionStorage.getItem("url") + "/api/count-solicitacoes", {
              headers: { Authorization: "Bearer " + this.getToken },
            })
            .then((response) => {
              if (response.data.status == "Token is Expired") {
                this.$store.commit("DESTROY_USER");
                this.$router.push("/");
              }
              this.qnt2 = response.data;
            });
        }
      }
    },

    index() {
      this.$router.push("/Home");
    },
    redirect(item) {
      this.qnt = this.qnt - 1;

      axios
        .post(
          sessionStorage.getItem("url") + "/api/visualiza-notificacao",
          item,
          {
            headers: { Authorization: "Bearer " + this.getToken },
          }
        )
        .then((response) => {
          if (response.data.status == "Token is Expired") {
            this.$store.commit("DESTROY_USER");
            this.$router.push("/");
          }
          if (item.redirect != null) {
            this.$router.push(item.redirect);
          }
          this.initialize();
        });
    },
    temPermissao(item) {
      return item.meta.roles.includes(this.getTipo);
    },
    getUrlImg() {
      if (
        this.carregouImg &&
        this.getFotoPerfil != null &&
        this.getFotoPerfil != ""
      ) {
        return this.url + "/storage/" + this.getFotoPerfil;
      } else {
        return require("@/assets/default1.jpg");
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 10;
}
</style>
